import { render, staticRenderFns } from "./medicalReportList.vue?vue&type=template&id=31740de3&scoped=true"
import script from "./medicalReportList.vue?vue&type=script&lang=js"
export * from "./medicalReportList.vue?vue&type=script&lang=js"
import style0 from "./medicalReportList.vue?vue&type=style&index=0&id=31740de3&prod&lang=scss&scoped=true"
import style1 from "./medicalReportList.vue?vue&type=style&index=1&id=31740de3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31740de3",
  null
  
)

export default component.exports